module.exports = {
  en: require('./en.json'),
  sw: require('./sw.json'),
  es: require('./es.json')
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/locale/index.js
// module id = 90
// module chunks = 0 1 2